import React, { useContext, useEffect, useMemo } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import {
  COLOR_MODE_STORAGE_KEY,
  StyleContext,
} from "../context/styleContext";
import { createAppTheme } from "../styles/theme";

export default function AppThemeProvider({ children }) {
  const { colorMode } = useContext(StyleContext);
  const theme = useMemo(() => createAppTheme(colorMode), [colorMode]);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", colorMode);
    document.body.setAttribute("data-theme", colorMode);
    localStorage.setItem(COLOR_MODE_STORAGE_KEY, colorMode);

    let meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "theme-color";
      document.head.appendChild(meta);
    }
    meta.content = colorMode === "dark" ? "#0c1017" : "#eef1f6";
  }, [colorMode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      {children}
    </ThemeProvider>
  );
}
